import axios from 'axios';

export const FETCH_GAME_SETTINGS_REQUEST = 'FETCH_GAME_SETTINGS_REQUEST';
export const FETCH_GAME_SETTINGS_SUCCESS = 'FETCH_GAME_SETTINGS_SUCCESS';
export const FETCH_GAME_SETTINGS_FAILURE = 'FETCH_GAME_SETTINGS_FAILURE';

export const ADD_GAME_SETTINGS_SUCCESS = 'ADD_GAME_SETTINGS_SUCCESS';
export const UPDATE_GAME_SETTINGS_SUCCESS = 'UPDATE_GAME_SETTINGS_SUCCESS';

export const GAME_UPLOAD_STATUS = 'GAME_UPLOAD_STATUS';


 

const base_url  = process.env.REACT_APP_API_URL_ADMIN;


export const getGameSettings= () => async (dispatch) => {
    dispatch({ type: FETCH_GAME_SETTINGS_REQUEST });
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'settings',
            command: 'getSettings',
        });
        console.log(base_url)
        dispatch({
            type: FETCH_GAME_SETTINGS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        dispatch({
            type: FETCH_GAME_SETTINGS_FAILURE,
            payload: error.response?.data?.message || 'Failed to fetch game settings',
        });
        throw error;
    }

    
}

export const uploadGame = () => async (dispatch) => {
    try {
        const response = await axios.post(`${base_url}`, {
            apiName: 'settings',
            command: 'uploadGame'
        });
        dispatch({
            type: GAME_UPLOAD_STATUS,
            payload: response.data.data
        });
        return response.data.data;
    } catch (error) {
        throw error.response?.data?.message || 'Failed to stop script';
    }
};


